import { makeStyles, Typography } from "@material-ui/core";
import { Variant } from "@material-ui/core/styles/createTypography";
import { Button } from "@resource/atlas";
import { FunctionComponent } from "react";
import useAnalytics from "react-hooks/useAnalytics";
import { ResourceCustomTheme } from "styles/config";
import { renderedTextEditorStyling } from "styles/legacy/utils";
import { sanitizeHtml } from "utils";

const useStyles = makeStyles((theme: ResourceCustomTheme) => ({
  container: {
    "& a": {
      textDecoration: "underline",
    },
    ...theme.mixins.moduleStyles(theme),
    "& > h4": {
      marginTop: 0,
    },
    "& > h3": {
      marginTop: 0,
    },
  },
  placeholdersBody: renderedTextEditorStyling(theme, "body"),
  placeholdersHeader: renderedTextEditorStyling(theme, "header"),
}));

type AssessmentProps = {
  descriptionHtml?: string;
  header?: string;
  headerTag?: Variant;
  assessmentUrl?: string;
  assessmentLabel?: string;
};

const Assessment: FunctionComponent<AssessmentProps> = ({
  header,
  descriptionHtml,
  assessmentUrl,
  assessmentLabel,
  headerTag = "h4",
}) => {
  const analytics = useAnalytics();
  const styles = useStyles();

  if (!descriptionHtml && !header && !assessmentUrl) {
    return null;
  }

  return (
    <div className={styles.container}>
      {header && (
        <Typography
          className={styles.placeholdersHeader}
          variant={headerTag}
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(header) }}
        />
      )}
      {descriptionHtml && (
        <div
          className={styles.placeholdersBody}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(descriptionHtml),
          }}
        />
      )}

      {assessmentUrl && (
        <div className="flex">
          <Button
            as="a"
            variant="primary"
            className="mt-4 !no-underline"
            href={assessmentUrl}
            target="_blank"
            rel="noopen noreferrer"
            onClick={() => {
              analytics.track("View Assessment Clicked");
            }}
          >
            {assessmentLabel ?? "View your assessment"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default Assessment;
